<template>
  <div class="font">
    <div class="logo">
      <router-link to="/"
        ><div><img src="../assets/normal-logo.png" alt="logo" /></div
      ></router-link>
    </div>
    <div class="error-page" v-if="errorPage">
      Token has expired, please reset password again <router-link to="/forget-password">here</router-link>
    </div>
    <div v-else>
      <div class="head">
          <h3>Reset Password</h3>
          <p>Enter and confirm your new password.</p>
      </div>
      <div class="login-hero">
        <div class="login">
          <form action="">
            <div class="errors">
              <div class="form-input">
                <img src="../assets/padlock.svg" />
                <input
                  :class="{ error: $v.resetData.password.$error }"
                  type="password"
                  placeholder="New Password"
                  class="input"
                  @input="$v.resetData.password.$touch()"
                  v-model.trim="resetData.password"
                />
              </div>
              <div v-if="$v.resetData.password.$dirty">
                <span class="error-message" v-if="!$v.resetData.password.minLength">
                  Minimum Length required is 8 characters
                </span>
              </div>
            </div>
            <div class="errors">
              <div class="form-input">
                <img src="../assets/padlock.svg" />
                <input
                  :class="{ error: $v.confirmPassword.$error }"
                  type="password"
                  placeholder="Confirm Password"
                  class="input"
                  @input="$v.confirmPassword.$touch()"
                  v-model.trim="confirmPassword"
                />
              </div>
              <div v-if="$v.confirmPassword.$dirty">
                <span class="error-message" v-if="!$v.confirmPassword.minLength">
                  Minimum Length required is 8 characters
                </span>
              </div>
              <div v-if="confirmPassword !== resetData.password">
                <span class="error-message">
                  Password must match
                </span>
              </div>
            </div>
            <b-button
            v-if="getStatus === 'loading'"
            loading
              class="button"
              :disabled="!resetData.password || !confirmPassword || !passwordMatch || isLoading || $v.$invalid"
            >
            </b-button>
            <b-button
            v-else
              class="button"
              @click.prevent="submit"
              :disabled="!resetData.password || !confirmPassword || !passwordMatch || $v.$invalid"
            >
              <span>LOGIN</span>
            </b-button>
          </form>
        </div>
    </div>
      <div class="footer-login">
        <p>&copy; Uptima Solutions</p>
        <p>Terms & Conditions</p>
        <p>Privacy Policy</p>
      </div>
    </div>
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode';
import { mapActions, mapGetters } from 'vuex';
import { minLength } from 'vuelidate/lib/validators';

export default {
  name: 'ResetPassword',
  data() {
    return {
      resetData: {
        password: '',
        bearerToken: ''
      },
      confirmPassword: '',
      isLoading: false,
      errorPage: false,
      tokenWatch: ''
    };
  },
  validations: {
    resetData: {
      password: {
        minLength: minLength(8)
      }
    },
    confirmPassword: { minLength: minLength(8) }
  },
  computed: {
    ...mapGetters(['getStatus']),
    ...mapGetters('auth', ['isLoggedIn']),
    passwordMatch() {
      return this.resetData.password === this.confirmPassword;
    }
  },
  mounted() {
    localStorage.removeItem('vuex');
    this.isLoading = false;
    if (this.$route.query) {
      const { token } = this.$route.query;
      this.resetData.bearerToken = token;
      this.tokenWatch = token;
    }
  },
  watch: {
    isLoggedIn(value) {
      if (value) {
        setTimeout(() => {
          this.$router.push('/');
        }, 1000);
      }
    },
    getStatus(value) {
      if (value === 'error') {
        this.isLoading = false;
        this.$buefy.toast.open({
          message: 'Please try again',
          type: 'is-danger'
        });
      }
    },
    tokenWatch(value) {
      const token = jwtDecode(value);
      const time = Date.now().valueOf() / 1000;
      if (token.exp < time) {
        this.errorPage = true;
      }
    }
  },
  methods: {
    ...mapActions('auth', ['resetPassword']),
    submit() {
      this.isLoading = true;

      this.resetPassword(this.resetData);
      this.isLoading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.logo {
  padding: 45px 0 45px 100px;
}
.logo img {
  height: 50px;
}
.login-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.login {
  min-width: 528px;
  background: #fcfcfc;
  box-shadow: 4px 4px 10px rgba(210, 192, 192, 0.25), -4px -4px 10px rgba(210, 192, 192, 0.25);
  padding: 50px 70px;
}
.login p {
  text-align: center;
  margin-top: 56px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #817f7f;
}
.error-page {
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 75px;
  letter-spacing: 2px;
  color: red;
  text-align: center;
}
.head {
    text-align: center;
    h3 {
        font-style: normal;
        font-weight: bold;
        font-size: 26px;
        line-height: 75px;
        letter-spacing: 2px;
        color: #5051DB;
    }
    p {
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 30px;
        color: #000000;
        margin-bottom: 34px;
    }
}
h1 {
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 20px;
  color: #000000;
  text-align: center;
  margin-bottom: 46px;
}
.form-input {
  height: 45px;
  /* width: 80%; */
  background: #f6faff;
  border: 1px solid #e4e4e4;
  display: flex;
  padding: 0 18px;
  margin-bottom: 17px;
}
.error-message {
  color: red !important;
  font-size: 10px !important;
  margin: 0;
}
.errors {
  min-height: 90px;
}
input {
  border: none;
  outline: none;
}

.input {
  margin-left: 22px;
  width: 80%;
}

.input::-webkit-input-placeholder {
  color: #939393;
}
.input:focus::-webkit-input-placeholder {
  color: #5051db;
}
.check {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 27px;
  margin-top: 15px;
}
.flex-check {
  display: flex;
  align-items: center;
}
.flex-check span {
  margin-left: 9px;
}
.flex-check span {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 12px;
  color: #454141;
}
.button {
  background: #3887f6;
  border: 0.8px solid #5051db;
  width: 100%;
  padding: 15px 0;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #ffffff;
}
.button:hover {
  background: #5051db;
  border: 0.8px solid #5051db;
  transition: all ease-in-out 1s;
}
p {
  margin: 0;
}
.footer-login {
  margin-top: 68px;
  text-align: center;
}
.footer-login p:nth-child(1) {
  margin-bottom: 20px;
}
.footer-login p:nth-child(2) {
  margin-bottom: 8px;
}
button[disabled] {
  background: #1c17ff;
  cursor: not-allowed !important;
  opacity: 0.7 !important;
  color: #e4e4e4;
}
button[disabled]:hover {
  background: #1c17ff;
  cursor: not-allowed !important;
  opacity: 0.7 !important;
  color: #e4e4e4;
}
@media screen and (max-width: 768px) {
  .logo {
    padding: 50px 20px;
  }
  .login {
    min-width: 100%;
    padding: 20px;
  }
}
</style>
